import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('home');
  
  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: t('footer.address'),
      content: [
        t('footer.addressContent.0'),
        t('footer.addressContent.1')
      ]
    },
    {
      icon: 'ri-phone-line',
      title: t('footer.phone'),
      content: [t('footer.phoneContent.0')]
    },
    {
      icon: 'ri-printer-line',
      title: t('footer.fax'),
      content: [t('footer.faxContent.0')]
    },
    {
      icon: 'ri-mail-line',
      title: t('footer.email'),
      content: [t('footer.emailContent.0')]
    }
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer id="contact" className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-700 text-white">
      {/* Contact Info Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {contactInfo.map((info, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <i className={`${info.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">{info.title}</h3>
              <div className="space-y-1">
                {info.content.map((line, idx) => (
                  <p key={idx} className="text-sm">{line}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/90">
              {t('footer.copyright')}
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-white/90 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer z-40"
        aria-label={t('footer.backToTop')}
      >
        <i className="ri-arrow-up-line text-2xl"></i>
      </button>
    </footer>
  );
}
